import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TooltipButton } from "@/components/common/Tooltips";
import { API } from "@/lib/api";
import { toast } from "sonner";

// Botón reutilizable de exportación a Excel (XLSX) server-side, con descarga autenticada.
// La visibilidad por área la decide quien lo renderiza (AuthContext.hasArea).
export function ExportExcelButton({ endpoint, filename, label = "Exportar a Excel", testid, size = "sm", variant = "outline" }) {
  const [busy, setBusy] = useState(false);
  const descargar = async () => {
    setBusy(true);
    try {
      const token = localStorage.getItem("cos_token");
      const res = await fetch(`${API}${endpoint}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) {
        let msg = "No se pudo exportar.";
        try { msg = (await res.json()).detail || msg; } catch { /* noop */ }
        throw new Error(msg);
      }
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = filename || "export.xlsx";
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(a.href);
      toast.success("Archivo Excel generado.");
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <TooltipButton tooltip="Descargar los registros en formato Excel (XLSX)"
      data-testid={testid} size={size} variant={variant} disabled={busy} onClick={descargar}>
      {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Download className="mr-1.5 h-4 w-4" />} {label}
    </TooltipButton>
  );
}
